<template>
  <div class="gap-slot">
    <el-form ref="formRef" :model="formData" @change="submitHandler(formRef)">
      <el-row :gutter="20">
        <el-col :span="8">
          <el-form-item
            label="Ширина, %"
            prop="widthPercent"
            :rules="[{ required: true, message: 'Обязательное поле' }]"
          >
            <MagnerFormInput
              v-model.number="formData.widthPercent"
              :field="widthPercentField"
              @update:model-value="maxIntMask($event,'widthPercent')"
            />
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item
            label="Высота, %"
            prop="heightPercent"
            :rules="[{ required: true, message: 'Обязательное поле' }]"
          >
            <MagnerFormInput
              v-model.number="formData.heightPercent"
              :field="heightPercentField"
              @update:model-value="maxIntMask($event,'heightPercent')"
            />
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item
            label="Размер"
            prop="size"
            :rules="[{ required: true, message: 'Обязательное поле' }]"
          >
            <MagnerFormInput
              v-model.number="formData.size"
              :field="sizeField"
              @update:model-value="maxIntMask($event,'size')"
            />
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
  </div>
</template>

<script setup lang="ts">
import { onMounted, reactive, ref } from 'vue';
import { IGapWidget } from 'features/settings/onboarding-editor/interfaces';
import { WIDGET_TYPES } from 'features/settings/onboarding-editor/constants';
import { InputField, MagnerFormInput } from 'magner';
import { FormInstance } from 'element-plus';

interface Props {
  editData?: IGapWidget;
}

const props = withDefaults(defineProps<Props>(), {
  editData: undefined,
});
const emit = defineEmits(['update:formData', 'error']);

const state = props.editData && JSON.parse(JSON.stringify(props.editData));
const formRef = ref<FormInstance>();

const formData = reactive<IGapWidget>(
  state
  || {
    type: WIDGET_TYPES.GAP,
    widthPercent: 15.0,
    heightPercent: 15.0,
    size: 20.0,
  } as IGapWidget,
);

const widthPercentField: InputField<any> = {
  type: 'input',
  name: 'widthPercent',
  dataType: 'number',
  props: {
    mask: {
      mask: '###',
    },
  },
};

const heightPercentField: InputField<any> = {
  type: 'input',
  name: 'heightPercent',
  dataType: 'number',
  props: {
    mask: {
      mask: '###',
    },
  },
};

const sizeField: InputField<any> = {
  type: 'input',
  name: 'size',
  dataType: 'number',
  props: {
    mask: {
      mask: '###',
    },
  },
};

const maxIntMask = (value: number, field: keyof Omit<IGapWidget, 'type'>) => {
  const regExp = /^0[0-9]/;

  if (value > 100) {
    formData[field] = 100;
  } else if (regExp.test(String(value))) {
    formData[field] = 1;
  }
};

const submitHandler = (formEl: FormInstance | undefined) => {
  if (!formEl) {
    return;
  }

  formEl.validate((valid) => {
    if (valid) {
      emit('error', false);
      emit('update:formData', formData);
      return true;
    }

    emit('error', true);
    return false;
  });
};

onMounted(() => submitHandler(formRef.value));
</script>

<style lang="scss" scoped>
.gap-slot {
  :deep(.el-input-number .el-input__inner) {
    text-align: start !important;
  }
}
</style>
